import { useState } from 'react';

export default function useForm<T = any>(initial: T) {
  const [data, setData] = useState<T>(initial);

  const update = (field: string, value: any) =>
    setData((current) => ({
      ...current,
      [field]: value,
    }));

  const reset = () => setData({ ...initial });

  return {
    data,
    setData,
    update,
    reset,
  };
}
